export default __webpack_public_path__ + "static/media/OpenSans-SemiBold.a16d8201.ttf";